/* eslint-disable import/first */
import { message } from "antd";
import { actions as loadingActions } from "../../components/loading/index";
import { notification, Modal, Card } from "antd";
const { confirm } = Modal;
import React from "react";

export const modelFromStep = (visible, loading, step, itemIndex = null) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    // 
    dispatch({
      type: "HIDE_MODEL_FROM_STEP",
      payload: {
        visible,
        loading,
        step,
        itemIndex
      }
    });
  };
};

export const deleteItem = (val, category, arrayField) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    dispatch(loadingActions.showLoading());

    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;

    let data = {
      [category]: firestore.FieldValue.arrayRemove(val),
      [category + "Array"]: firestore.FieldValue.arrayRemove(val[arrayField])
    };
    // 

    firestore
      .doc(`students/${uid}`)
      .set(data, { merge: true })
      .then(function() {
        dispatch(loadingActions.hideLoading());
      })
      .catch(function(error) {
        // 
        message.error(
          "Something went wrong. Please refresh the page and try again" + error
        );
      });
  };
};

export const stepWithSkillsSubmit = (
  formVal,
  history,
  categary,
  step,
  arrayField,
  itemIndex = null
) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    //dispatch(loadingActions.showLoading());
    dispatch({
      type: "HIDE_MODEL_FROM_STEP",
      payload: {
        visible: true,
        loading: true,
        step: step,
        itemIndex: itemIndex
      }
    });
    // 
    // 
    if (typeof formVal.workshopDate !== "undefined") {
      // 
      formVal.workshopDate = formVal.workshopDate.toString();
    }
    if (typeof formVal.internshipDate !== "undefined") {
      formVal.internshipDate = formVal.internshipDate.toString();
    }
    if (typeof formVal.publicationDate !== "undefined") {
      formVal.publicationDate = formVal.publicationDate.toString();
    }
    if (typeof formVal.certificationDate !== "undefined") {
      formVal.certificationDate = formVal.certificationDate.toString();
    }
    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;

    // 
    if (itemIndex !== null) {
      const itemData = getState().firebase.profile[categary];
      itemData[itemIndex] = formVal;
      // 
      firestore
        .doc(`students/${uid}`)
        .set({ [categary]: itemData }, { merge: true })
        .then(function() {
          dispatch({
            type: "HIDE_MODEL_FROM_STEP",
            payload: {
              visible: false,
              loading: false,
              step: step,
              itemIndex: itemIndex
            }
          });
        })
        .catch(function(error) {
          // 
          message.error(
            "Something went wrong. Please refresh the page and try again" +
              error
          );
        });
    } else {
      let data = {
        [categary]: firestore.FieldValue.arrayUnion(formVal),
        [categary + "Array"]: firestore.FieldValue.arrayUnion(
          formVal[arrayField]
        )
      };
      
      firestore
        .doc(`students/${uid}`)
        .set(data, { merge: true })
        .then(function() {
          dispatch({
            type: "HIDE_MODEL_FROM_STEP",
            payload: {
              visible: false,
              loading: false,
              step: step,
              itemIndex: itemIndex
            }
          });
        })
        .catch(function(error) {
          // 
          message.error(
            "Something went wrong. Please refresh the page and try again" +
              error
          );
        });
    }
  };
};

export const loadProjectsList = () => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    dispatch(loadingActions.showLoading());
    // 

    firestore
    .collection("students")
    .orderBy("projectsDoneList", "asc")
      // .doc(skillName)
      // .collection("users")
      .get()
      .then(doc => {
        // 
        dispatch({
          type: "LOAD_PROJECT_LIST",
          payload: !doc.empty
            ? {
                valid: true,
                data: (doc.docs.map((doc, i) => {
                  if(doc.data().projectsDoneList){
                  return { key: `${i}`, ...doc.data(), ...Object.values(doc.data().projectsDoneList) };
                  }
                })).filter(function( element ) {
                  return element !== undefined;
               })
              }
            : { valid: false }
        });
        dispatch(loadingActions.hideLoading());
      })
      .catch(function(error) {
        
        dispatch(loadingActions.hideLoading());
      });
  };
};
